module.exports = __webpack_public_path__ + "static/media/FASNYLogoProcess4.fb3a2433.jpg";